const initialState = {
    menulist: [], 
  };
  
  const MenuReListducer = (state = initialState, action) => {
    switch (action.type) {
      case "SET_MENULIST":
        return {
          ...state,
          menulist: action.payload, 
        };
  
      case "REMOVE_MENULIST":
        return { ...initialState };
  
      default:
        return state;
    }
  };
  
  export default MenuReListducer;
  